<ag-grid-angular
  style="width: 100%; height: 400px"
  class="ag-theme-alpine"
  [rowData]="salesOrderFormLineItems"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  [defaultColDef]="defaultColDef"
  [stopEditingWhenCellsLoseFocus]="true"
  (cellValueChanged)="onCellValueChanged($event)"
></ag-grid-angular>
